import { render, staticRenderFns } from "./Bullets.vue?vue&type=template&id=2f39389a&functional=true&"
var script = {}
import style0 from "./Bullets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports